import { Box, Button, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { errorToastMessage } from "../../../utils/toast";
import { AxiosResponse } from "axios";
import http from "../../../utils/http";
import { useParams } from "react-router-dom";
import { FavouriteFilledIcon, FavouriteIcon } from "../../Common/assets/Icons";
import {
  addFavourites,
  sendAiQuery,
} from "../../../Redux/actions/aiSearchAction";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { setAiTabType } from "../../../Redux/reducers/aiSearchSlice";
import { DateTime } from "luxon";

const FavouritesTab = () => {
  const [loading, setLoading] = useState(true);
  const [favouritesData, setFavouritesData] = useState<any>([]);
  const { id: studyId } = useParams();

  const dispatch = useAppDispatch();

  const favouriteLoader = useAppSelector(
    (state) => state.aiSearch.favouriteLoader
  );

  const toggleFavourite = useAppSelector(
    (state) => state.aiSearch.toggleFavourite
  );

  const handleFavourite = (query: any) => {
    dispatch(addFavourites(query?.id, !query?.favourite));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res: AxiosResponse = await http.get(`/ai-query/favourites`);
        const resData = res?.data?.data;

        const newData = resData?.map((item: any) => ({
          id: item?.id,
          query: item?.userInput,
          time:
            item?.createdAt &&
            DateTime.fromISO(item?.createdAt).toFormat("EEE, dd yyyy  h:mm a"),
          favourite: item?.favourite,
        }));

        setFavouritesData(newData || []);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        errorToastMessage(err as Error);
      }
    };
    fetchData();
  }, [studyId, setLoading, toggleFavourite]);

  const handleRerun = (query: string) => {
    dispatch(sendAiQuery(query));
    dispatch(setAiTabType("aiSearch"));
  };

  return !loading ? (
    <>
      {favouritesData?.length > 0 ? (
        favouritesData?.map((item: any) => (
          <Box
            key={item?.id}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            py={2}
            borderBottom="1px solid #E5E7EB"
            gap={2}
          >
            <Box width={"80%"} display={"flex"} alignItems={"center"} gap={1}>
              <Box
                sx={{ cursor: "pointer" }}
                onClick={() => handleFavourite(item)}
                display={"flex"}
                alignItems={"center"}
              >
                {favouriteLoader !== item?.id ? (
                  item?.favourite ? (
                    <FavouriteFilledIcon />
                  ) : (
                    <FavouriteIcon />
                  )
                ) : (
                  <Box>
                    <CircularProgress size={18} />
                  </Box>
                )}
              </Box>
              <Typography
                variant="body1"
                fontWeight="regular"
                color="text.primary"
              >
                {item?.query || "-"}
              </Typography>
            </Box>

            <Button
              variant="outlined"
              sx={{ width: "74px" }}
              onClick={() => handleRerun(item?.query)}
            >
              Rerun
            </Button>
          </Box>
        ))
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 5,
          }}
        >
          No Favourites Available
        </Box>
      )}
    </>
  ) : (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <CircularProgress size={25} />
    </Box>
  );
};

export default FavouritesTab;
